
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <base-card with_divider>
        <template slot="title">
          <span class="text-capitalize">
            {{ $tc('stages.new')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="stageForm">
            <v-text-field 
              :placeholder="$t('stages.name_form_label')"
              solo flat class="black--text" style="font-weight: 900; font-size: large !important;"
              v-model="new_stage.name" dense
              :rules="required"
            ></v-text-field>

            <v-row align="center" class="pa-3" v-if="false && max_positions > 1">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('position') }}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="new_stage.position"
                  :rules="[
                    ruleNumberEqualLessThan(max_positions),
                    ruleNumberEqualGreaterThan(1)
                  ]"
                  type="number" min="1"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{$t('stages.quantity_alterations')}}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="new_stage.qtd_alterations"
                  :rules="[ruleNumberEqualGreaterThan(0)]"
                  type="number" min="0"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('stages.expected_duration_form_label') }}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="new_stage.default_duration_days"
                  :rules="[ruleNumberEqualGreaterThan(1)]"
                  type="number" min="1"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancel" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="save" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'DialogNewStage',
  mixins: [ validations ],
  props: {
    one_stage: {
      type: Object,
    },
    position: {
      type: [String, Number],
    },
    max_positions: {
      type: [String, Number],
    },
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,
      new_stage: {
        status: 'not_started',
        name: null,
        position: null,
        // kind: null,
        use_type: 'template',
        default_duration_days: 10,
        started_at: null,
        expected_conclusion_at: null,
        json_attributes: {},
          // subtasks: [],
          description: null,
          qtd_alterations: 0,
      },

      default_task: {
        name: null,
        status: 'open',
        due_at: null,
        done_at: null, 
      },
    }
  },
  methods: {
    setupStage() {
      if (this.one_stage){
        this.new_stage = {
          ...this.new_stage,
          ...this.one_stage,
        }
      } if (this.position){
        this.new_stage.position = this.position
      }
    },
    cancel(){
      this.$emit('cancel')
    },
    save(){
      if (this.$refs.stageForm.validate()){
        this.$emit('done', {...this.new_stage})
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.setupStage()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style lang="scss" scoped>
::v-deep.rounder.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
  border: solid 1px #a5a5a5;
}
</style>